import React, { useState, useEffect } from "react";
import api from "../../api/api";
import ToastMessage from "../../utils/mui/righttoptoast";
import { Skeleton } from "@mui/material";

const PurposeModal = ({ setScreen, selectedAppointment, fetchScheduleData, selectedDate,closeAllModals }) => {
  const [activeButton, setActiveButton] = useState(null);  // To track the selected visit purpose
  const [purposeOptions, setPurposeOptions] = useState([]);  // State to hold fetched visit purpose options
  const [loading, setLoading] = useState(false);  // Loading state
  const practiseid = window.getPracticeId();
  const [selectedPurpose, setSelectedPurpose] = useState('');  // Store selected visit purpose
      const [openToast, setOpenToast] = useState(false);
      const [toastMessage, setToastMessage] = useState('');
      const [toastSeverity, setToastSeverity] = useState('success');
  // Fetch visit purpose data
  const fetchPurposeData = async () => {
    setLoading(true);  // Start loading
    try {
      const response = await api.post(`/v1/${practiseid}/appointment/types`,{
        "providerid":[]
      });
      if (response.status === 200) {
        setPurposeOptions(response.data);  // Set the visit purpose options
      } else {
        setPurposeOptions([]); 
      }
    } catch (error) {
      console.error(error);
      setPurposeOptions([]);  // In case of error, clear the options
    } finally {
      setLoading(false);  // Stop loading
    }
  };

  // Fetch visit purpose data when component mounts
  useEffect(() => {
    fetchPurposeData();
  }, []);

  const handleToastClose = () => {
    setOpenToast(false)
};

  const SelectDate = new Date(selectedAppointment.startdate);
  const formattedDate =
    SelectDate.getFullYear() +
    "-" +
    (SelectDate.getMonth() + 1).toString().padStart(2, "0") +
    "-" +
    SelectDate.getDate().toString().padStart(2, "0");

  // Update visit purpose
  const UpdateVisitPurpose = async ({ selectedPurpose }) => {
   
    try {
      const response = await api.put(
        `/v1/${practiseid}/appointments/visit-purpose/update`,
        {
          itemVal: [selectedPurpose],
          dtype: ["dtpurpose"],
          app_id: [selectedAppointment.appointmentid],
          cid: [selectedAppointment.AID ?? selectedAppointment.id],
          searchdate: formattedDate,
        }
      );

      if (response.status === 200) {
        fetchScheduleData(selectedDate);  // Re-fetch schedule data
        setToastMessage("Purpose Updated successfully");
        setToastSeverity('success');
        setOpenToast(true);
      } else {
        console.error("Update failed.");
        setToastMessage('Failed to Update Purpose. Please try again.');
        setToastSeverity('info');
        setOpenToast(true);
      }
    } catch (error) {
      console.error("Error updating visit purpose:", error);
      setToastMessage('Something Went Wrong');
      setToastSeverity('error');
      setOpenToast(true);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      {/* Popup Box */}
      <div className="relative flex flex-col gap-4 md:w-[60%] w-[80%] bg-white rounded-lg shadow-lg text-left">
        <div>
          <div className="w-full flex items-center justify-between mt-2 p-2 px-4">
            {/* Close Button */}
            <span className="ml-2 font-semibold text-[#1D2951] text-base text-center tracking-[0] leading-[normal] whitespace-nowrap">
              Select Visit Purpose 
            </span>
            <button
              className="text-gray-500 hover:text-gray-700 text-[30px]"
              onClick={()=>{
                setScreen(0)
              }}
            >
              &times;
            </button>
          </div>
          <div className="h-px bg-[#D0D5DD]"></div>
        </div>

        {/* Purpose Buttons */}
        <div className="flex flex-wrap gap-4 p-4">
          {loading ? (
            <div>{
              // Display skeletons while loading
              Array.from({ length: 3 }).map((_, index) => (
                  <Skeleton
                      key={index}
                      variant="rectangular"
                      width={100}
                      height={35}
                      style={{ margin: '8px', borderRadius: '50px' }}
                  />
              ))
}</div> // Show loading message or spinner while fetching data
          ) : (
            purposeOptions && Array.isArray(purposeOptions) && purposeOptions.length > 0 ? (
              purposeOptions.map((purpose, index) => (
                <button
                  key={index}
                  className={`rounded-full py-2 px-3 font-inter text-[12px] shadow-md border-[1.5px] border-gray-200 truncate ${
                    activeButton === purpose.value ? "bg-[#E17954] text-white" : "bg-[#F3F3F3] text-[#374151]"
                  }`}
                  onClick={() => {
                    setActiveButton(purpose.value);  // Set selected visit purpose
                    setSelectedPurpose(purpose.value);  // Set visit purpose for update
                  }}
                >
                  {purpose.value} {/* Assuming visit purpose has a 'purposeName' property */}
                </button>
              ))
            ) : (
              <div>No visit purposes found.</div> // If no purposes found, show a message
            )
          )}
        </div>

        {/* Update Button */}
        <div className="w-full flex justify-center mt-2 py-4 border-t bg-[#F9FAFB] rounded">
          <button
            onClick={() => UpdateVisitPurpose({ selectedPurpose })}
            className="rounded py-2 px-4 w-[90%] font-inter transition duration-300 ease-in-out shadow-[0px_4px_4px_#00000040] bg-[black] text-[#FFFFFF]"
          >
            Update
          </button>
        </div>
      </div>
      <ToastMessage
          message={toastMessage}
          severity={toastSeverity}
          open={openToast}
          handleClose={handleToastClose}
        />
    </div>
  );
};

export default PurposeModal;
